import BackToView from "components/BackToView/BackToView";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";

const BackToSettingsView = () => {
	return (
		<BackToView to={ABSOLUTE_PATHS.SETTINGS} text="Volver a Configuración" />
	);
}

export default BackToSettingsView;